<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{smsMode ? "SMS " : ""}}Message Driver</span>
    </v-card-title>
    <v-layout pa-2 px-3 row wrap>
      <v-flex xs12>
        <v-textarea
          v-model="message"
          maxlength="500"
          label="Message"
          placeholder="Enter your message"
        ></v-textarea>
      </v-flex>
      <v-flex xs12>
        <p style="color: red;">{{error}}</p>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="text-none" flat text @click="sent">Cancel</v-btn>
      <v-btn class="text-none" flat text @click="sendMessage">Send Message</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "MessageDriverDialog",
  model: {
    prop: "time",
    event: "input"
  },
  props: {
    taxi: Object,
    smsMode: {
      type: Boolean,
      default: false
    },
    number: String,
  },
  data() {
    return {
      message: "",
      error: ""
    };
  },
  methods: {
    sent: function() {
      this.$emit("sent");
    },
    sendMessage: async function() {
      if (this.smsMode) {
        this.sendMessageSMS();
        return;
      }

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/overwatch/sendMessage?message=${this.message}&taxi_id=${this.taxi.id}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        if (response.data.error == "no_error") {
          this.$emit("sent");
        } else {
          this.error = response.data.error;
        }
      } catch (e) {
        console.log(e);
        this.error = "Unknown Error";
      }
    },
    sendMessageSMS: async function() {
      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/customMessage?message=${
            this.message
          }&contact_number=${this.number.trim()}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        if (response.data.error == "no_error") {
          this.$emit("sent");
        } else {
          this.error = response.data.error;
        }
      } catch (e) {
        console.log(e);
        this.error = "Unknown Error";
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
